module.exports = __webpack_public_path__ + "assets/img/27_1243.f8994c1c.jpg";